module.exports = __webpack_public_path__ + "static/media/noemi_perez.625e66e1.png";